/**
 * Calculate percentage loaded based on current values
 */
export var percentLoaded = function percentLoaded(loaded, total) {
    return Math.ceil(loaded / total * 100);
};

/**
 * Performs an HTTP request with upload progress
 *
 * @param {string} url - resource to post
 * @param {FormData} data - FormData to post
 * @param {(percentLoaded: number) => void} onProgress - function that will be invoked on each progress event
 * @returns Promise<string>
 */
export var httpWithUploadProgress = function httpWithUploadProgress(url, data, onProgress) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();

        xhr.addEventListener('load', function () {
            if (xhr.status >= 300) {
                reject();
            } else {
                resolve(xhr.responseText);
            }
        });
        xhr.addEventListener('error', function () {
            return reject();
        });
        xhr.addEventListener('abort', function () {
            return reject();
        });
        if (xhr.upload) {
            xhr.upload.addEventListener('progress', function (event) {
                if (Number.isFinite(event.loaded) && Number.isFinite(event.total)) {
                    onProgress(percentLoaded(event.loaded, event.total));
                }
            });
        }
        xhr.open('POST', url, true);
        xhr.send(data);
    });
};